import _ from 'lodash'
import { setLaunchProgress, setTexts } from '../data'
import getLocalizedTexts from '../localization'
import { constants } from '../imports'

const LaunchProgressBarMiddleware = store => next => (action) => {
    switch (action.type) {
        case constants.LOCALE_CHANGED: {
            const result = next(action)
            const texts = getLocalizedTexts(action.payload)
            store.dispatch(setTexts(texts))
            return result
        }

        // Whenever we receive process running information from
        // the backend, we want to update our progress state
        case constants.PROCESS_CHANGED: {
            _.forOwn(action.payload, (serverProcesses, serverId) => {
                // These are recently started processes, so I want to reset their
                // progress to 0, but I want to make sure that the client has opened
                // up for the user, so I wait 10 seconds before resetting the progress
                serverProcesses.started.map(userId =>
                    setTimeout(() => {
                        store.dispatch(setLaunchProgress(serverId, userId, 0))
                    }, 10000),
                )

                // These are recently stopped processes, since the user has closed
                // his client, we want to immediately reset the progress to 0
                serverProcesses.stopped.map(userId =>
                    store.dispatch(setLaunchProgress(serverId, userId, 0)),
                )
            })

            return next(action)
        }

        default:
            return next(action)
    }
}

export default LaunchProgressBarMiddleware



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/middleware/index.js